import { Component, Signal, input, signal } from '@angular/core';

import { Subject } from 'rxjs';

import { FontIconComponent } from '@camelot/icons';
import { TranslatePipe } from '@camelot/translation';
import {
  ButtonComponent,
  ErrorComponent,
  LayoutSideComponent,
  LayoutSideContentComponent,
  LayoutSideCtaComponent,
  LoaderComponent,
} from '@camelot/ui';
import { CamBaseComponent, RequestState } from '@camelot/utils';

import { CamTranslationCore } from '../../translation.service';

@Component({
  selector: 'cam-panel-form-layout',
  templateUrl: './panel-form-layout.component.html',
  styleUrls: ['./panel-form-layout.component.scss'],
  imports: [
    ButtonComponent,
    LayoutSideCtaComponent,
    LayoutSideComponent,
    LayoutSideContentComponent,
    LoaderComponent,
    FontIconComponent,
    TranslatePipe,
    ErrorComponent,
  ],
})
export class PanelFormLayoutComponent {
  askValidation$ = input.required<Subject<null>>();

  formValidity = input.required<Signal<boolean>>();

  parentRequestState = input.required<RequestState>();

  constructor() {
    CamTranslationCore.getInstance();
  }
}

@Component({
  host: { 'data-cid': 'abstract-panel-form-layout' },
  template: '',
  standalone: false,
})
export abstract class AbstractPanelFormLayout extends CamBaseComponent {
  readonly askValidation$ = new Subject<null>();
  public formValidity = signal(true);

  public setValidy(valid: boolean) {
    this.formValidity.set(valid);
  }
}
